import { defineMessages } from 'react-intl'

const scope = 'modules.vendor.components.creditCardProviderInlineCreate'

export default defineMessages({
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: 'New provider name',
  },
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'Enter provider name',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  createErrorToastTitle: {
    id: `${scope}.createErrorToastTitle`,
    defaultMessage: 'Error',
  },
  createErrorToastMessage: {
    id: `${scope}.createErrorToastMessage`,
    defaultMessage: 'Unable to create the credit card provider.',
  },
})
